import le, { useRef as re, useLayoutEffect as ce, useState as D, useCallback as ue, useEffect as ee } from "react";
var G = { exports: {} }, F = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ne;
function de() {
  if (ne) return F;
  ne = 1;
  var i = Symbol.for("react.transitional.element"), a = Symbol.for("react.fragment");
  function d(n, p, h) {
    var T = null;
    if (h !== void 0 && (T = "" + h), p.key !== void 0 && (T = "" + p.key), "key" in p) {
      h = {};
      for (var j in p)
        j !== "key" && (h[j] = p[j]);
    } else h = p;
    return p = h.ref, {
      $$typeof: i,
      type: n,
      key: T,
      ref: p !== void 0 ? p : null,
      props: h
    };
  }
  return F.Fragment = a, F.jsx = d, F.jsxs = d, F;
}
var W = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oe;
function fe() {
  return oe || (oe = 1, process.env.NODE_ENV !== "production" && function() {
    function i(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === g ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case R:
          return "Fragment";
        case H:
          return "Profiler";
        case k:
          return "StrictMode";
        case Z:
          return "Suspense";
        case q:
          return "SuspenseList";
        case Q:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case U:
            return "Portal";
          case c:
            return (e.displayName || "Context") + ".Provider";
          case B:
            return (e._context.displayName || "Context") + ".Consumer";
          case v:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case J:
            return t = e.displayName || null, t !== null ? t : i(e.type) || "Memo";
          case m:
            t = e._payload, e = e._init;
            try {
              return i(e(t));
            } catch {
            }
        }
      return null;
    }
    function a(e) {
      return "" + e;
    }
    function d(e) {
      try {
        a(e);
        var t = !1;
      } catch {
        t = !0;
      }
      if (t) {
        t = console;
        var r = t.error, o = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return r.call(
          t,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          o
        ), a(e);
      }
    }
    function n(e) {
      if (e === R) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === m)
        return "<...>";
      try {
        var t = i(e);
        return t ? "<" + t + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function p() {
      var e = I.A;
      return e === null ? null : e.getOwner();
    }
    function h() {
      return Error("react-stack-top-frame");
    }
    function T(e) {
      if (E.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function j(e, t) {
      function r() {
        w || (w = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          t
        ));
      }
      r.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: r,
        configurable: !0
      });
    }
    function M() {
      var e = i(this.type);
      return N[e] || (N[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function O(e, t, r, o, b, x, S, Y) {
      return r = x.ref, e = {
        $$typeof: C,
        type: e,
        key: t,
        props: x,
        _owner: b
      }, (r !== void 0 ? r : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: M
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: S
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Y
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function $(e, t, r, o, b, x, S, Y) {
      var s = t.children;
      if (s !== void 0)
        if (o)
          if (P(s)) {
            for (o = 0; o < s.length; o++)
              z(s[o]);
            Object.freeze && Object.freeze(s);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else z(s);
      if (E.call(t, "key")) {
        s = i(e);
        var y = Object.keys(t).filter(function(X) {
          return X !== "key";
        });
        o = 0 < y.length ? "{key: someKey, " + y.join(": ..., ") + ": ...}" : "{key: someKey}", l[s + o] || (y = 0 < y.length ? "{" + y.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          o,
          s,
          y,
          s
        ), l[s + o] = !0);
      }
      if (s = null, r !== void 0 && (d(r), s = "" + r), T(t) && (d(t.key), s = "" + t.key), "key" in t) {
        r = {};
        for (var V in t)
          V !== "key" && (r[V] = t[V]);
      } else r = t;
      return s && j(
        r,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), O(
        e,
        s,
        x,
        b,
        p(),
        r,
        S,
        Y
      );
    }
    function z(e) {
      typeof e == "object" && e !== null && e.$$typeof === C && e._store && (e._store.validated = 1);
    }
    var L = le, C = Symbol.for("react.transitional.element"), U = Symbol.for("react.portal"), R = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), H = Symbol.for("react.profiler"), B = Symbol.for("react.consumer"), c = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), q = Symbol.for("react.suspense_list"), J = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), Q = Symbol.for("react.activity"), g = Symbol.for("react.client.reference"), I = L.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, E = Object.prototype.hasOwnProperty, P = Array.isArray, _ = console.createTask ? console.createTask : function() {
      return null;
    };
    L = {
      "react-stack-bottom-frame": function(e) {
        return e();
      }
    };
    var w, N = {}, A = L["react-stack-bottom-frame"].bind(
      L,
      h
    )(), u = _(n(h)), l = {};
    W.Fragment = R, W.jsx = function(e, t, r, o, b) {
      var x = 1e4 > I.recentlyCreatedOwnerStacks++;
      return $(
        e,
        t,
        r,
        !1,
        o,
        b,
        x ? Error("react-stack-top-frame") : A,
        x ? _(n(e)) : u
      );
    }, W.jsxs = function(e, t, r, o, b) {
      var x = 1e4 > I.recentlyCreatedOwnerStacks++;
      return $(
        e,
        t,
        r,
        !0,
        o,
        b,
        x ? Error("react-stack-top-frame") : A,
        x ? _(n(e)) : u
      );
    };
  }()), W;
}
var ie;
function pe() {
  return ie || (ie = 1, process.env.NODE_ENV === "production" ? G.exports = de() : G.exports = fe()), G.exports;
}
var f = pe(), me = process.env.NODE_ENV === "production", te = "Invariant failed";
function se(i, a) {
  if (!i) {
    if (me)
      throw new Error(te);
    var d = typeof a == "function" ? a() : a, n = d ? "".concat(te, ": ").concat(d) : te;
    throw new Error(n);
  }
}
function xe(i) {
  const a = re(null);
  return ce(() => {
    if (!a.current)
      return;
    const d = new ResizeObserver((n) => {
      se(n[0], "ResizeObserver should have at least one entry"), i(n[0].contentRect.width);
    });
    return d.observe(a.current), i(a.current.getBoundingClientRect().width), () => {
      d.disconnect();
    };
  }, [i]), a;
}
function he(i, a, d, n) {
  const p = n === "taller" ? Math.max(a, d) : Math.min(a, d);
  return i * p;
}
function ae(i) {
  return i.naturalHeight / i.naturalWidth;
}
const ge = (i) => {
  const {
    aspectRatio: a = "taller",
    handle: d = null,
    handleSize: n = 40,
    hover: p = !1,
    leftImage: h,
    leftImageAlt: T = "",
    leftImageCss: j = {},
    leftImageLabel: M = null,
    onSliderPositionChange: O,
    rightImage: $,
    rightImageAlt: z = "",
    rightImageCss: L = {},
    rightImageLabel: C = null,
    skeleton: U = null,
    sliderLineColor: R = "#ffffff",
    sliderLineWidth: k = 2,
    sliderPositionPercentage: H = 0.5,
    vertical: B = !1
  } = i, c = !B, [v, Z] = D(
    H
  ), [q, J] = D(!1), [m, Q] = D(0), [g, I] = D(0), E = xe((l) => Q(l)), P = re(null), _ = re(null), [w, N] = D(!1), A = ue(() => {
    var l, e;
    (l = _.current) != null && l.complete && ((e = P.current) != null && e.complete) && N(!0);
  }, []);
  ee(() => (A(), () => {
    N(!1);
  }), [h, $]), ee(() => {
    if (!(_.current && P.current) || m === 0 || !w)
      return;
    const l = he(
      m,
      ae(_.current),
      ae(P.current),
      a
    );
    I(l);
  }, [m, w, a]), ee(() => {
    if (!E.current || !w)
      return;
    const l = (o) => {
      if (!E.current)
        return;
      const b = E.current.getBoundingClientRect();
      let x, S;
      if (o instanceof TouchEvent) {
        const K = o.touches[0];
        se(K), x = K.clientX, S = K.clientY;
      } else
        x = o.clientX, S = o.clientY;
      const Y = c ? x - b.left : S - b.top, s = k / 2, y = c ? m - s : g - s, X = Math.min(
        Math.max(Y, s),
        y
      ) / (c ? m : g);
      Z(X), O == null || O(X);
    }, e = (o) => {
      J(!0), "touches" in o || o.preventDefault(), l(o), window.addEventListener("mousemove", l), window.addEventListener("touchmove", l);
    }, t = () => {
      J(!1), window.removeEventListener("mousemove", l), window.removeEventListener("touchmove", l);
    }, r = E.current;
    return r.addEventListener("touchstart", e), window.addEventListener("touchend", t), p ? (r.addEventListener("mousemove", l), r.addEventListener("mouseleave", t)) : (r.addEventListener("mousedown", e), window.addEventListener("mouseup", t)), () => {
      r.removeEventListener("touchstart", e), window.removeEventListener("touchend", t), r.removeEventListener("mousemove", l), r.removeEventListener("mouseleave", t), r.removeEventListener("mousedown", e), window.removeEventListener("mouseup", t), window.removeEventListener("mousemove", l), window.removeEventListener("touchmove", l);
    };
  }, [
    w,
    a,
    g,
    m,
    c,
    p,
    k,
    E
    // onSliderPositionChange, // may cause infinite loop
  ]);
  const u = {
    container: {
      boxSizing: "border-box",
      position: "relative",
      width: "100%",
      height: `${g}px`,
      overflow: "hidden"
    },
    rightImage: {
      clipPath: c ? `inset(0px 0px 0px ${m * v}px)` : `inset(${g * v}px 0px 0px 0px)`,
      display: "block",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      width: "100%",
      ...L
    },
    leftImage: {
      clipPath: c ? `inset(0px ${m * (1 - v)}px 0px 0px)` : `inset(0px 0px ${g * (1 - v)}px 0px)`,
      display: "block",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      width: "100%",
      ...j
    },
    slider: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      ...c ? {
        cursor: "ew-resize",
        flexDirection: "column",
        height: "100%",
        left: `${m * v - n / 2}px`,
        top: 0,
        width: `${n}px`
      } : {
        cursor: "ns-resize",
        flexDirection: "row",
        height: `${n}px`,
        left: 0,
        top: `${g * v - n / 2}px`,
        width: "100%"
      }
    },
    line: {
      background: R,
      boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
      flex: "0 1 auto",
      height: c ? "100%" : `${k}px`,
      width: c ? `${k}px` : "100%"
    },
    handleCustom: {
      alignItems: "center",
      boxSizing: "border-box",
      display: "flex",
      flex: "1 0 auto",
      height: "auto",
      justifyContent: "center",
      width: "auto"
    },
    handleDefault: {
      alignItems: "center",
      border: `${k}px solid ${R}`,
      borderRadius: "100%",
      boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
      boxSizing: "border-box",
      display: "flex",
      flex: "1 0 auto",
      height: `${n}px`,
      justifyContent: "center",
      width: `${n}px`,
      transform: c ? "none" : "rotate(90deg)"
    },
    leftArrow: {
      border: `inset ${n * 0.15}px rgba(0,0,0,0)`,
      borderRight: `${n * 0.15}px solid ${R}`,
      height: "0px",
      marginLeft: `-${n * 0.25}px`,
      // for IE11
      marginRight: `${n * 0.25}px`,
      width: "0px"
    },
    rightArrow: {
      border: `inset ${n * 0.15}px rgba(0,0,0,0)`,
      borderLeft: `${n * 0.15}px solid ${R}`,
      height: "0px",
      marginRight: `-${n * 0.25}px`,
      // for IE11
      width: "0px"
    },
    leftLabel: {
      background: "rgba(0, 0, 0, 0.5)",
      color: "white",
      left: c ? "5%" : "50%",
      opacity: q ? 0 : 1,
      padding: "10px 20px",
      position: "absolute",
      top: c ? "50%" : "3%",
      transform: c ? "translate(0,-50%)" : "translate(-50%, 0)",
      transition: "opacity 0.1s ease-out"
    },
    rightLabel: {
      background: "rgba(0, 0, 0, 0.5)",
      color: "white",
      opacity: q ? 0 : 1,
      padding: "10px 20px",
      position: "absolute",
      ...c ? {
        right: "5%",
        top: "50%",
        transform: "translate(0,-50%)"
      } : {
        left: "50%",
        bottom: "3%",
        transform: "translate(-50%, 0)"
      },
      transition: "opacity 0.1s ease-out"
    },
    leftLabelContainer: {
      clipPath: c ? `inset(0px ${m * (1 - v)}px 0px 0px)` : `inset(0px 0px ${g * (1 - v)}px 0px)`,
      height: "100%",
      position: "absolute",
      width: "100%"
    },
    rightLabelContainer: {
      clipPath: c ? `inset(0px 0px 0px ${m * v}px)` : `inset(${g * v}px 0px 0px 0px)`,
      height: "100%",
      position: "absolute",
      width: "100%"
    }
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    U && !w && /* @__PURE__ */ f.jsx("div", { style: { ...u.container }, children: U }),
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        style: {
          ...u.container,
          display: w ? "block" : "none"
        },
        ref: E,
        "data-testid": "container",
        children: [
          /* @__PURE__ */ f.jsx(
            "img",
            {
              onLoad: () => A(),
              alt: z,
              "data-testid": "right-image",
              ref: P,
              src: $,
              style: u.rightImage
            }
          ),
          /* @__PURE__ */ f.jsx(
            "img",
            {
              onLoad: () => A(),
              alt: T,
              "data-testid": "left-image",
              ref: _,
              src: h,
              style: u.leftImage
            }
          ),
          /* @__PURE__ */ f.jsxs("div", { style: u.slider, children: [
            /* @__PURE__ */ f.jsx("div", { style: u.line }),
            d ? /* @__PURE__ */ f.jsx("div", { style: u.handleCustom, children: d }) : /* @__PURE__ */ f.jsxs("div", { style: u.handleDefault, children: [
              /* @__PURE__ */ f.jsx("div", { style: u.leftArrow }),
              /* @__PURE__ */ f.jsx("div", { style: u.rightArrow })
            ] }),
            /* @__PURE__ */ f.jsx("div", { style: u.line })
          ] }),
          M && /* @__PURE__ */ f.jsx("div", { style: u.leftLabelContainer, children: /* @__PURE__ */ f.jsx("div", { style: u.leftLabel, children: M }) }),
          C && /* @__PURE__ */ f.jsx("div", { style: u.rightLabelContainer, children: /* @__PURE__ */ f.jsx("div", { style: u.rightLabel, children: C }) })
        ]
      }
    )
  ] });
};
export {
  ge as default
};
